import { Box, Button, Grid } from '@material-ui/core'
import { useCallback, useEffect, useRef } from 'react'
import { useSessaoAtual, useToastSaurus } from 'services/app'
import { FormPropagandaCadastro } from 'views/components/form/master/propaganda/propaganda-cadastro/form-propaganda-cadastro'
import { DefaultFormRefs } from 'views/components/form/utils'
import { useStyles } from '../../propaganda-criacao-styles'
import { usePostCadastrarPropaganda } from 'data/api/gestao/propaganda/post-cadastrar-propaganda'
import { PropagandaFormFields } from 'model/app/forms/propaganda/propaganda-form-fields'
import { PropagandaModel } from 'model/api/gestao/propaganda/propaganda-model'
import { picker } from 'utils/picker'
import { OkIcon } from 'views/components/icons'
import { useHistory } from 'react-router-dom'

export const PropagandaCriacaoContent = () => {
    const { postCadastrarPropaganda, carregando } = usePostCadastrarPropaganda();
    const { showToast } = useToastSaurus();
    const classes = useStyles();
    const { push } = useHistory();
    const {usuario} = useSessaoAtual();
    const formRef = useRef<DefaultFormRefs<PropagandaFormFields>>(null)

    const recarregarForm = useCallback((modelForm: PropagandaFormFields) => {
        formRef.current?.fillForm(modelForm)
    }, [])

    const handleSubmit = useCallback(async (modelF: PropagandaFormFields) => {
        try {
            const respostasDisponiveis = modelF.respostasDisponiveis
                .split(';')
                .map(r => r.trim())
                .filter(r => r.length > 0);

            const propagandaToCreate = picker<PropagandaModel>(
                modelF,
                new PropagandaModel(),
            );

            propagandaToCreate.respostasDisponiveis = respostasDisponiveis;
            propagandaToCreate.revendaId = usuario?.Id ?? null;

            const res = await postCadastrarPropaganda(propagandaToCreate);

            if (res.erro) throw res.erro;

            const resultado = res.resultado?.data as PropagandaModel;
            const id = resultado.id;

            push(`/propaganda/editar/${id}`);
            showToast('success', 'Propaganda cadastratada.');

        } catch (e: any) {
            showToast('error', e.message);
        }
    }, [postCadastrarPropaganda, push, showToast, usuario?.Id]);

    useEffect(() => {
        recarregarForm(new PropagandaFormFields());
    }, [recarregarForm])

    return (
        <Grid
            container
            style={{ height: '100%' }}
        >
            <Grid item xs={12} container className={classes.formCadastro}>
                <FormPropagandaCadastro
                    onSubmit={handleSubmit}
                    loading={carregando}
                    showLoading={carregando}
                    ref={formRef}
                />
                <Box p={2}>
                    <Button size='large' fullWidth variant='contained' color='primary'
                        onClick={() => {
                            const sucesso = formRef.current?.submitForm();

                            if (!sucesso) {
                                showToast('error', 'Preencha todos os campos obrigatórios corretamente.');
                                return;
                            }
                        }}>
                        <OkIcon tipo="BUTTON_PRIMARY"></OkIcon>  Salvar
                    </Button>
                </Box>
            </Grid>
        </Grid>

    )
}


